(() => {
  const STORAGE_KEY = 'labosch_visual_theme';
  const normalize = (value) => value === 'light' ? 'light' : 'dark';
  const read = () => { try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; } };
  const write = (value) => { try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {} };

  const mountGlobalSwitch = () => {
    const button = document.querySelector('.labosch-theme-switch');
    if (!button) return;
    try {
      button.classList.remove('labosch-theme-switch--in-header');
      button.classList.add('labosch-theme-switch--bottom-left');
      if (button.parentNode !== document.body) document.body.appendChild(button);
    } catch (e) {}
  };

  const apply = (theme, persist = true) => {
    const value = normalize(theme);
    document.documentElement.setAttribute('data-lbx-color-scheme', value);
    document.body?.setAttribute('data-lbx-color-scheme', value);
    document.querySelectorAll('[data-lbx-world-home]').forEach((root) => root.setAttribute('data-lbx-theme', value));
    document.querySelectorAll('[data-lbx-advisor-modal], .lbxw-quiz').forEach((modal) => modal.setAttribute('data-lbx-theme', value));
    document.querySelectorAll('[data-labosch-theme-switch]').forEach((button) => {
      button.setAttribute('aria-pressed', value === 'dark' ? 'true' : 'false');
      button.setAttribute('aria-label', value === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro');
      button.title = value === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
    });
    if (persist) write(value);
    mountGlobalSwitch();
    document.dispatchEvent(new CustomEvent('labosch:theme-change', { detail: { theme: value } }));
  };

  const init = () => {
    const saved = read();
    const fallback = document.documentElement.getAttribute('data-lbx-color-scheme') || document.body?.getAttribute('data-lbx-color-scheme') || 'light';
    apply(saved || fallback || 'light', false);

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-labosch-theme-switch]');
      if (!button) return;
      event.preventDefault();
      const current = normalize(document.documentElement.getAttribute('data-lbx-color-scheme') || 'light');
      apply(current === 'dark' ? 'light' : 'dark');
    });

    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes && mutation.addedNodes.length)) return;
      const current = normalize(document.documentElement.getAttribute('data-lbx-color-scheme') || 'light');
      apply(current, false);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', mountGlobalSwitch, { once: true });
})();


/* v102: default visual theme = dark unless the user explicitly saved light */
(function () {
  try {
    var html = document.documentElement;
    var body = document.body;
    var keys = ['labosch_visual_theme', 'labosch_theme', 'lbx_color_scheme', 'labosch_color_scheme'];
    var saved = null;

    for (var i = 0; i < keys.length; i++) {
      var value = localStorage.getItem(keys[i]);
      if (value === 'light' || value === 'dark') {
        saved = value;
        break;
      }
    }

    var current = normalize(html.getAttribute('data-lbx-color-scheme')) || normalize(html.getAttribute('data-labosch-theme')) || normalize(html.getAttribute('data-theme')) || (body && (normalize(body.getAttribute('data-lbx-color-scheme')) || normalize(body.getAttribute('data-labosch-theme')) || normalize(body.getAttribute('data-theme')))) || 'light';
    var scheme = saved || current;

    html.setAttribute('data-lbx-color-scheme', scheme);
    html.setAttribute('data-labosch-theme', scheme);
    html.classList.toggle('labosch-dark', scheme === 'dark');
    html.classList.toggle('labosch-light', scheme === 'light');
    html.style.colorScheme = scheme;

    if (body) {
      body.setAttribute('data-lbx-color-scheme', scheme);
      body.setAttribute('data-labosch-theme', scheme);
      body.classList.toggle('labosch-dark', scheme === 'dark');
      body.classList.toggle('labosch-light', scheme === 'light');
    }
  } catch (e) {}
})();


/* v138 — robust global light/dark switch, including catalogue collection */
(function () {
  var STORAGE_KEYS = ['labosch_visual_theme', 'labosch_theme', 'lbx_color_scheme', 'labosch_color_scheme'];
  var SWITCH_SELECTOR = '[data-labosch-theme-switch], .labosch-theme-switch';

  function normalize(value) {
    value = String(value || '').toLowerCase();
    if (value.indexOf('light') !== -1 || value.indexOf('claro') !== -1) return 'light';
    if (value.indexOf('dark') !== -1 || value.indexOf('oscuro') !== -1) return 'dark';
    return '';
  }

  function readStoredTheme() {
    for (var i = 0; i < STORAGE_KEYS.length; i++) {
      try {
        var value = normalize(localStorage.getItem(STORAGE_KEYS[i]));
        if (value) return value;
      } catch (e) {}
    }
    return '';
  }

  function writeStoredTheme(theme) {
    for (var i = 0; i < STORAGE_KEYS.length; i++) {
      try { localStorage.setItem(STORAGE_KEYS[i], theme); } catch (e) {}
    }
  }

  function getCurrentTheme() {
    var html = document.documentElement;
    var body = document.body;

    return normalize(html.getAttribute('data-lbx-color-scheme')) ||
      normalize(html.getAttribute('data-labosch-theme')) ||
      normalize(html.getAttribute('data-theme')) ||
      normalize(body && body.getAttribute('data-lbx-color-scheme')) ||
      normalize(body && body.getAttribute('data-labosch-theme')) ||
      normalize(body && body.getAttribute('data-theme')) ||
      readStoredTheme() ||
      (html.classList.contains('labosch-dark') || html.classList.contains('dark') || (body && (body.classList.contains('labosch-dark') || body.classList.contains('dark'))) ? 'dark' : 'light');
  }

  function applyNodeTheme(node, theme) {
    if (!node) return;

    node.setAttribute('data-lbx-color-scheme', theme);
    node.setAttribute('data-labosch-theme', theme);
    node.setAttribute('data-theme', theme);
    node.style.colorScheme = theme;

    node.classList.toggle('labosch-dark', theme === 'dark');
    node.classList.toggle('labosch-light', theme === 'light');
    node.classList.toggle('dark', theme === 'dark');
    node.classList.toggle('light', theme === 'light');
  }

  function syncCustomRoots(theme) {
    document.querySelectorAll('[data-lbx-world-home], [data-lbx-advisor-modal], .lbxw-quiz').forEach(function (el) {
      el.setAttribute('data-lbx-theme', theme);
    });

    document.querySelectorAll('[data-lbx-catalog], .lbxcat').forEach(function (catalog) {
      catalog.setAttribute('data-lbx-theme', theme);
      catalog.classList.toggle('is-dark', theme === 'dark');
      catalog.classList.toggle('is-light', theme === 'light');
    });

    document.querySelectorAll('[data-lbx-comparator], .lbx-comparator').forEach(function (comparator) {
      comparator.setAttribute('data-lbx-theme', theme);
      comparator.setAttribute('data-lbx-resolved-theme', theme);
    });
  }

  function syncButtons(theme) {
    document.querySelectorAll(SWITCH_SELECTOR).forEach(function (button) {
      button.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      button.setAttribute('aria-label', theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro');
      button.title = theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
      button.classList.toggle('is-dark', theme === 'dark');
      button.classList.toggle('is-light', theme === 'light');
    });
  }

  function applyTheme(theme, persist) {
    theme = normalize(theme) || 'light';

    applyNodeTheme(document.documentElement, theme);
    applyNodeTheme(document.body, theme);
    syncCustomRoots(theme);
    syncButtons(theme);

    if (persist !== false) writeStoredTheme(theme);

    try {
      document.dispatchEvent(new CustomEvent('labosch:theme-change', {
        detail: { theme: theme, source: 'global-theme-switch-v138' }
      }));
    } catch (e) {}
  }

  function toggleTheme(event) {
    var button = event && event.target && event.target.closest ? event.target.closest(SWITCH_SELECTOR) : null;
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    applyTheme(getCurrentTheme() === 'dark' ? 'light' : 'dark', true);
  }

  function init() {
    applyTheme(readStoredTheme() || getCurrentTheme() || 'light', false);

    document.addEventListener('click', toggleTheme, true);

    document.addEventListener('keydown', function (event) {
      var button = event.target && event.target.closest ? event.target.closest(SWITCH_SELECTOR) : null;
      if (!button) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      toggleTheme(event);
    }, true);

    document.addEventListener('labosch:theme-change', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.source === 'global-theme-switch-v138') return;
      var theme = normalize(detail.theme);
      if (theme) applyTheme(theme, false);
    }, true);

    var observer = new MutationObserver(function () {
      var theme = getCurrentTheme();
      syncCustomRoots(theme);
      syncButtons(theme);
    });

    [document.documentElement, document.body].filter(Boolean).forEach(function (node) {
      observer.observe(node, {
        attributes: true,
        attributeFilter: ['data-lbx-color-scheme', 'data-labosch-theme', 'data-theme', 'class']
      });
    });

    [0, 120, 420, 900, 1600].forEach(function (delay) {
      window.setTimeout(function () {
        applyTheme(readStoredTheme() || getCurrentTheme() || 'light', false);
      }, delay);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
